import { useLoadingToast } from "./root/useLoadingToast";
import { useUpdateFailureToast } from "./root/useUpdateFailureToast";
import { useWorkspaceToolsSync } from "./root/useWorkspaceToolsSync";
import { WorkspaceToolsErrorModal } from "./root/WorkspaceToolsErrorModal";
import { WorkspaceToolsReloadConfirm } from "./root/WorkspaceToolsReloadConfirm";

export const WorkspaceToolsRoot = () => {
	useWorkspaceToolsSync();
	useLoadingToast();
	useUpdateFailureToast();

	return (
		<>
			<WorkspaceToolsErrorModal />
			<WorkspaceToolsReloadConfirm />
		</>
	);
};
